import { render, staticRenderFns } from "./blacklist-index.vue?vue&type=template&id=a50c913a&"
import script from "./blacklist-index.vue?vue&type=script&lang=js&"
export * from "./blacklist-index.vue?vue&type=script&lang=js&"
import style0 from "./blacklist-index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports